var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Sensibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 17.19A20.81 20.81 0 1058.81 38 20.83 20.83 0 0038 17.19zm0 37.62A16.81 16.81 0 1154.81 38 16.83 16.83 0 0138 54.81zm0-29.12A12.31 12.31 0 1050.31 38 12.32 12.32 0 0038 25.69zm0 20.62A8.31 8.31 0 1146.31 38 8.32 8.32 0 0138 46.31zM42 38a4 4 0 11-7.999 0A4 4 0 0142 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Sensibility.193ee017.svg";
export { SvgG1Sensibility as ReactComponent };